// @ts-check

import { useCallback } from "react";
import { useOrgConfigForWorkspace } from "./useOrgConfigForWorkspace";

/**
 * Hook for managing workspace branding config.
 */
export const useOrgBrandingForWorkspace = () => {
  const { config, loading, update, updating } = useOrgConfigForWorkspace();

  const updateBranding = useCallback(
    /**
     * @param {org_config.workspace.Branding} newBranding
     * @returns {Promise<boolean>}
     */
    async (newBranding) => {
      return update({
        branding: newBranding,
      });
    },
    [update]
  );

  return {
    loading,
    branding: config?.branding,
    update: updateBranding,
    updating,
  };
};
